import common from './common'
import testPaperEvaluation from './testPaperEvaluation'
import exam from './exam'

export default {
  common,
  testPaperEvaluation,
  exam
}
